module.exports = __webpack_public_path__ + "static/img/8071c477e9c0be6475b1228078007794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro6.png
// module id = ymPj
// module chunks = 1